import { z } from 'zod';

/**
 * Pagination metadata structure for response
 */
export const paginationMetadata = z.object({
  totalItems: z.number(),
  itemsPerPage: z.number(),
  currentPage: z.number(),
  totalPages: z.number(),
  hasNextPage: z.boolean(),
  isFirstPage: z.boolean(),
  isLastPage: z.boolean(),
});
